<div class="checks-divider">
    @for (check of checks; track $index) {
        @if (check === CHECK.KO_OCR) {
            @if (suppressOcrKoChecks) {
                <tec-item
                    [classes]="['item--outline']"
                    [outline]="true"
                    [tagImage]="getTagImageByError(0)"
                    [tagIcon]="{icon: 'icon-alert', status: 'error', size: 'sm'}"
                    [title]="exclusiveKoCompletionDisplayOcr"
                    [clickeable]="false"
                />
            } @else if (processHelper.shouldShowOperationKoReason(detail?.data?.OCR)) {
                <ng-container
                    [ngTemplateOutlet]="CHECK_KO_GENERAL"
                    [ngTemplateOutletContext]="{
                        code: detail?.data?.OCR?.actions?.KO?.details?.error?.error_code,
                        error: detail?.data?.OCR?.actions?.KO?.details?.error,
                        operation: showOperationPrefix ? OPERATION_TYPE.OCR : undefined
                    }
                "/>
            }
        }
        @if (check === CHECK.KO_POL) {
            @if (suppressPolKoChecks) {
                <tec-item
                    [classes]="['item--outline']"
                    [outline]="true"
                    [tagImage]="getTagImageByError(0)"
                    [tagIcon]="{icon: 'icon-alert', status: 'error', size: 'sm'}"
                    [title]="exclusiveKoCompletionDisplayPol"
                    [clickeable]="false"
                />
            } @else if (processHelper.shouldShowOperationKoReason(detail?.data?.POL)) {
                <ng-container
                    [ngTemplateOutlet]="CHECK_KO_GENERAL"
                    [ngTemplateOutletContext]="{
                        code: detail?.data?.POL?.actions?.KO?.details?.error?.error_code,
                        error: detail?.data?.POL?.actions?.KO?.details?.error,
                        operation: showOperationPrefix ? OPERATION_TYPE.POL : undefined,
                        polData: detail?.data?.POL?.data
                    }"
                />
            }
        }
        @if (check === CHECK.KO_ATTORNEY_POWERS) {
            @if (
                detail?.data?.ATTORNEY_POWERS?.state === OPERATION_STATUS.KO &&
                (detail?.data?.ATTORNEY_POWERS?.actions?.KO || detail?.data?.ATTORNEY_POWERS?.details)
            ) {
                @if (processHelper.resolveAttorneyPowersKoDisplayCode(detail?.data?.ATTORNEY_POWERS); as attorneyKoCode) {
                    <ng-container
                        [ngTemplateOutlet]="CHECK_KO_GENERAL"
                        [ngTemplateOutletContext]="{
                            code: attorneyKoCode,
                            error: detail?.data?.ATTORNEY_POWERS?.actions?.KO?.details?.error,
                            operation: showOperationPrefix ? OPERATION_TYPE.ATTORNEY_POWERS : undefined
                        }"
                    />
                } @else {
                    <tec-item
                        [classes]="['item--outline']"
                        [outline]="true"
                        [tagImage]="getTagImageByError(0)"
                        [tagIcon]="{icon: 'icon-alert', status: 'error', size: 'sm'}"
                        [title]="
                            (showOperationPrefix
                                ? ('PROCESSES.DETAIL.KO_ERROR_TITLE_PREFIX_ATTORNEY_POWERS' | translate)
                                : '') +
                            (detail?.data?.ATTORNEY_POWERS?.details ||
                                detail?.data?.ATTORNEY_POWERS?.actions?.KO?.details?.error?.msg ||
                                ('ERRORS.PROCESS.TITLE_GENERIC' | translate))
                        "
                        [clickeable]="false"
                    />
                }
            }
        }
        @if (check === CHECK.KO_DOCUMENTS) {
            @if (processHelper.shouldShowOperationKoReason(detail?.data?.DOCUMENTS)) {
                <ng-container
                    [ngTemplateOutlet]="CHECK_KO_GENERAL"
                    [ngTemplateOutletContext]="{
                        code: detail?.data?.DOCUMENTS?.actions?.KO?.details?.error?.error_code,
                        error: detail?.data?.DOCUMENTS?.actions?.KO?.details?.error,
                        operation: showOperationPrefix ? OPERATION_TYPE.DOCUMENTS : undefined
                    }"
                />
            }
        }
        @if (check === CHECK.OCR_DOCUMENT_TYPE) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('DOCUMENT_TYPE')) {
                <ng-container [ngTemplateOutlet]="CHECK_OCR_DOCUMENT_TYPE"/>
            }
        }
        @if (check === CHECK.COUNTRY) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('COUNTRY')) {
                <ng-container [ngTemplateOutlet]="CHECK_COUNTRY"/>
            }
        }
        @if (check === CHECK.EXPIRATED) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('EXPIRATED')) {
                <ng-container [ngTemplateOutlet]="CHECK_EXPIRATED"/>
            }
        }
        @if (check === CHECK.LEGAL_AGE) {
            @if (!suppressOcrKoChecks && processHelper.ocrDocumentAgeKnown && shouldShowOcrAntifraud('LEGAL_AGE')) {
                <ng-container [ngTemplateOutlet]="CHECK_LEGAL_AGE"/>
            }
        }
        @if (check === CHECK.READ_MRZ) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('MRZ_VALIDATE')) {
                <ng-container [ngTemplateOutlet]="CHECK_READ_MRZ"/>
            }
        }
        @if (check === CHECK.AEAT) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('AEAT')) {
                <ng-container [ngTemplateOutlet]="CHECK_AEAT"/>
            }
        }
        @if (check === CHECK.AML) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('AML')) {
                <ng-container [ngTemplateOutlet]="CHECK_AML"/>
            }
        }
        @if (check === CHECK.PEP) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('PEP')) {
                <ng-container [ngTemplateOutlet]="CHECK_PEP"/>
            }
        }
        @if (check === CHECK.PROHIBITED_CAMERAS_OCR) {
            @if (!suppressOcrKoChecks && shouldShowOcrAntifraud('PROHIBITED_CAMERAS')) {
                <app-item-check-prohibited-cameras [status]="detail?.data?.OCR?.antifraud?.PROHIBITED_CAMERAS" />
            }
        }
        @if (check === CHECK.PROHIBITED_CAMERAS_POL) {
            @if (!suppressPolKoChecks && shouldShowPolAntifraud('PROHIBITED_CAMERAS')) {
                <app-item-check-prohibited-cameras [status]="detail?.data?.POL?.antifraud?.PROHIBITED_CAMERAS" />
            }
        }
        @if (check === CHECK.PHOTOCOPY) {
            @if (!suppressOcrKoChecks && canShowOcrImageFraud() && shouldShowOcrAntifraud('PHOTOCOPY')) {
                <ng-container [ngTemplateOutlet]="CHECK_PHOTOCOPY"/>
            }
        }
        @if (check === CHECK.SCREENPHOTO) {
            @if (!suppressOcrKoChecks && canShowOcrImageFraud() && shouldShowOcrAntifraud('SCREENPHOTO')) {
                <ng-container [ngTemplateOutlet]="CHECK_SCREENPHOTO"/>
            }
        }
        @if (check === CHECK.MANIPULATED_PHOTO) {
            @if (!suppressOcrKoChecks && canShowOcrImageFraud() && shouldShowOcrAntifraud('MANIPULATED_PHOTO')) {
                <ng-container [ngTemplateOutlet]="CHECK_MANIPULATED_PHOTO"/>
            }
        }
        @if (check === CHECK.FRAUD_ID_BLOCK) {
            @if (
                detail?.locks?.blocked_identifiers?.length
            ) {
                <ng-container [ngTemplateOutlet]="CHECK_FRAUD_ID_BLOCK"/>
            }
        }
        @if (check === CHECK.FACIAL_RECOGNITION) {
            @if (!suppressPolKoChecks && shouldShowPolAntifraud('FACIAL_RECOGNITION')) {
                <app-item-check-facial-recognition
                    [detail]="detail?.data?.POL"
                    [birthdate]="detail?.data?.OCR?.birthdate"
                    [polImages]="detail?.data?.POL?.images"
                    [ocrImages]="detail?.data?.OCR?.images"
                />
            }
        }
        @if (check === CHECK.FRAUD_FACE) {
            @if (!suppressPolKoChecks && shouldShowPolAntifraud('FRAUD_FACE')) {
                <app-item-check-fraud-face [status]="detail?.data?.POL?.antifraud?.FRAUD_FACE" />
            }
        }
        @if (check === CHECK.ANTISPOOF) {
            @if (!suppressPolKoChecks && shouldShowPolAntifraud('ANTISPOOF')) {
                <ng-container [ngTemplateOutlet]="CHECK_POL_ANTISPOOF"/>
            }
        }
        @if (check === CHECK.ANTISPOOF_LAB) {
            @if (!suppressPolKoChecks && rolePermissions.isSuperadmin() && shouldShowPolAntifraud('ANTISPOOF_LAB')) {
                <ng-container [ngTemplateOutlet]="CHECK_POL_ANTISPOOF_LAB"/>
            }
        }
        @if (check === CHECK.FRAUD_FACE_BLOCK) {
            @if (
                detail?.locks?.blocked_faces?.length
            ) {
                <app-item-check-fraud-face-block
                    [status]="detail?.locks?.blocked_faces?.length ? 'KO' : 'OK'"
                    [locks]="detail?.locks"
                />
            }
        }
        @if (check === CHECK.RANGE_AGE && rolePermissions.isSuperadmin()) {
            @if (!suppressPolKoChecks && processHelper.ocrDocumentAgeKnown && shouldShowPolAntifraud('RANGE_AGE')) {
                <ng-container [ngTemplateOutlet]="CHECK_RANGE_AGE"/>
            }
        }
        @if (shouldRenderDocsEval(check)) {
            <app-checks-docs-eval
                [check]="check"
                [detail]="detail"
                [showOnlyKO]="showOnlyKO"
                (openDocumentsCompare)="openDocumentsCompareModal($event.doc, $event.event)"
                (openFormMatchModal)="showFormMatchModal = true"
            />
        }
    }
</div>

<app-checks-modals
    [detail]="detail"
    [showAeatModal]="showAeatModal"
    [showMrzModal]="showMrzModal"
    [showFormMatchModal]="showFormMatchModal"
    [compareModalDoc]="compareModalDoc"
    [compareModalRows]="compareModalRows"
    [compareModalHasMismatch]="compareModalHasMismatch"
    [formMatchCompareRows]="formMatchCompareRows"
    [formMatchCompareHasMismatch]="formMatchCompareHasMismatch"
    [formMatchDataModalTitleKey]="formMatchDataModalTitleKey"
    [formMatchDataModalAlertKey]="formMatchDataModalAlertKey"
    [showMrzAlert]="shouldShowOcrAntifraud('MRZ_VALIDATE') && detail?.data?.OCR?.antifraud?.MRZ_VALIDATE === BOOLEAN_STATUS.KO"
    (showAeatModalChange)="showAeatModal = $event"
    (showMrzModalChange)="showMrzModal = $event"
    (showFormMatchModalChange)="showFormMatchModal = $event"
    (closeDocumentsCompare)="closeDocumentsCompareModal()"
/>

<ng-template #CHECK_READ_MRZ>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.MRZ_VALIDATE)"
        [title]="'PROCESSES.DETAIL.READ_MRZ' | translate"
        [clickeable]="false">
        @if (detail?.data?.OCR?.antifraud?.MRZ_VALIDATE && hasOcrMrzLines()) {
            <tec-link (click)="showMrzModal = true">
                {{ 'GENERAL.SHOW_DETAILS' | translate }}
            </tec-link>
        }
    </tec-item>
</ng-template>

<ng-template #CHECK_AEAT>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.AEAT)"
        [title]="'PROCESSES.DETAIL.AEAT' | translate"
        [clickeable]="false">
        @if (detail?.data?.OCR?.actions?.AEAT?.details) {
            <tec-link (click)="showAeatModal = true">
                {{ 'GENERAL.SHOW_DETAILS' | translate }}
            </tec-link>
        }
    </tec-item>
</ng-template>

<ng-template #CHECK_AML>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.AML)"
        [title]="'PROCESSES.DETAIL.AML' | translate"
        [clickeable]="false">
        <tec-list-detail>
            <span>{{
                (detail?.data?.OCR?.antifraud?.AML === BOOLEAN_STATUS.OK
                    ? 'PROCESSES.DETAIL.AML_RESULT_OK'
                    : 'PROCESSES.DETAIL.AML_RESULT_KO'
                ) | translate
            }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_PEP>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.PEP)"
        [title]="'PROCESSES.DETAIL.PEP' | translate"
        [clickeable]="false"
    >
        <tec-list-detail>
            <span>{{
                (detail?.data?.OCR?.antifraud?.PEP === BOOLEAN_STATUS.OK
                    ? 'PROCESSES.DETAIL.PEP_RESULT_OK'
                    : 'PROCESSES.DETAIL.PEP_RESULT_KO'
                ) | translate
            }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_PROHIBITED_CAMERAS>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-shield', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.PROHIBITED_CAMERAS || detail?.data?.POL?.antifraud?.PROHIBITED_CAMERAS)"
        [title]="'PROCESSES.DETAIL.PROHIBITED_CAMERAS' | translate"
        [clickeable]="false"
    ></tec-item>
</ng-template>

<ng-template #CHECK_FRAUD_ID_BLOCK>
    <!-- TODO no me llega -->
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-shield', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.locks?.blocked_identifiers?.length ? 'KO' : 'OK')"
        [title]="'PROCESSES.DETAIL.FRAUD_ID_BLOCK' | translate"
        [clickeable]="false"
    >
        <tec-list-detail>
            <span>{{
                (!detail?.locks?.blocked_identifiers?.length
                    ? 'PROCESSES.DETAIL.FRAUD_ID_BLOCK_RESULT_OK'
                    : 'PROCESSES.DETAIL.FRAUD_ID_BLOCK_RESULT_KO'
                ) | translate
            }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_RANGE_AGE>
    <tec-item
        [classes]="['item--outline']"
        [tagImage]="{icon: 'icon-list-ticks', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.POL?.antifraud?.RANGE_AGE)"
        [title]="'PROCESSES.DETAIL.RANGE_AGE' | translate"
        [clickeable]="false">
        <tec-list-detail>
            <span>{{ 'PROCESSES.DETAIL.ESTIMATED_AGE' | translate: {lowAge: detail?.data?.POL?.low_age, highAge: detail?.data?.POL?.high_age, yearsOld: processHelper.yearsOld} }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_MANIPULATED_PHOTO>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-shield', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.MANIPULATED_PHOTO)"
        [title]="'PROCESSES.DETAIL.MANIPULATED_PHOTO' | translate"
        [clickeable]="false">
        @for (entry of ocrImageFraudKoEntries('MANIPULATED_PHOTO'); track entry.captureIndex) {
            <tec-list-detail>
                <span>{{ ocrDocumentSideLabel(entry.document_side, entry.captureIndex) }}: {{ 'GENERAL.RELIABILITY' | translate: {reliability: ocrImageFraudReliability(entry.details)} }}</span>
            </tec-list-detail>
        }
        @if (!ocrImageFraudBySide('MANIPULATED_PHOTO')?.length && isOcrImageFraudKo('MANIPULATED_PHOTO') && detail?.data?.OCR?.actions?.MANIPULATED_PHOTO?.details) {
            <tec-list-detail>
                <span>{{ 'GENERAL.RELIABILITY' | translate: {reliability: (-detail?.data?.OCR?.actions?.MANIPULATED_PHOTO?.details*100+100).toFixed(2)} }}</span>
            </tec-list-detail>
        }
    </tec-item>
</ng-template>

<ng-template #CHECK_PHOTOCOPY>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-shield', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.PHOTOCOPY)"
        [title]="'PROCESSES.DETAIL.PHOTOCOPY' | translate"
        [clickeable]="false">
        @for (entry of ocrImageFraudKoEntries('PHOTOCOPY'); track entry.captureIndex) {
            <tec-list-detail>
                <span>{{ ocrDocumentSideLabel(entry.document_side, entry.captureIndex) }}: {{ 'GENERAL.RELIABILITY' | translate: {reliability: ocrImageFraudReliability(entry.details)} }}</span>
            </tec-list-detail>
        }
        @if (!ocrImageFraudBySide('PHOTOCOPY')?.length && isOcrImageFraudKo('PHOTOCOPY') && detail?.data?.OCR?.actions?.PHOTOCOPY?.details) {
            <tec-list-detail>
                <span>{{ 'GENERAL.RELIABILITY' | translate: {reliability: (-detail?.data?.OCR?.actions?.PHOTOCOPY?.details*100+100).toFixed(2)} }}</span>
            </tec-list-detail>
        }
    </tec-item>
</ng-template>

<ng-template #CHECK_SCREENPHOTO>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-shield', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.SCREENPHOTO)"
        [title]="'PROCESSES.DETAIL.SCREENPHOTO' | translate"
        [clickeable]="false">
        @for (entry of ocrImageFraudKoEntries('SCREENPHOTO'); track entry.captureIndex) {
            <tec-list-detail>
                <span>{{ ocrDocumentSideLabel(entry.document_side, entry.captureIndex) }}: {{ 'GENERAL.RELIABILITY' | translate: {reliability: ocrImageFraudReliability(entry.details)} }}</span>
            </tec-list-detail>
        }
        @if (!ocrImageFraudBySide('SCREENPHOTO')?.length && isOcrImageFraudKo('SCREENPHOTO') && detail?.data?.OCR?.actions?.SCREENPHOTO?.details) {
            <tec-list-detail>
                <span>{{ 'GENERAL.RELIABILITY' | translate: {reliability: (-detail?.data?.OCR?.actions?.SCREENPHOTO?.details*100+100).toFixed(2)} }}</span>
            </tec-list-detail>
        }
    </tec-item>
</ng-template>

<ng-template #CHECK_KO_GENERAL let-code="code" let-error="error" let-operation="operation" let-polData="polData">
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="getTagImageByError(code)"
        [tagIcon]="{icon: 'icon-alert', status: 'error', size: 'sm'}"
        [title]="processHelper.detailKoGeneral(code, operation, polData, error)?.title"
        [clickeable]="false">
        <tec-list-detail>
            <span>{{ processHelper.detailKoGeneral(code, operation, polData, error)?.subtitle }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_OCR_DOCUMENT_TYPE>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-list-ticks', status: 'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.DOCUMENT_TYPE)"
        [title]="'PROCESSES.DETAIL.DOCUMENT_TYPE' | translate"
        [clickeable]="false">
        <tec-list-detail>
            <span>{{ masterService.getDocumentTypeLabel(detail?.data?.OCR?.document_type) }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_COUNTRY>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-list-ticks', status: 'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.COUNTRY)"
        [title]="'PROCESSES.DETAIL.COUNTRY' | translate"
        [clickeable]="false">
        <tec-list-detail>
            <span>{{ masterService.getNameCountry(detail?.data?.OCR?.country) || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_EXPIRATED>
    <tec-item
    [classes]="['item--outline']"
    [outline]="true"
    [tagImage]="{icon: 'icon-list-ticks', status: 'simple'}"
    [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.EXPIRATED)"
    [title]="'PROCESSES.DETAIL.DOCUMENT_EXPIRED' | translate"
    [clickeable]="false">
    @if (detail?.data?.OCR?.actions?.EXPIRATED?.showModal) {
        <tec-link (click)="showModalGenericInfo('EXPIRY_DATE', detail?.data?.OCR?.actions?.EXPIRATED?.details?.allowed_days)">
            {{ 'GENERAL.SHOW_DETAILS' | translate }}
        </tec-link>
    }
    <tec-list-detail>
        <span>{{ (detail?.data?.OCR?.expiration_date | expirationDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
    </tec-list-detail>
</tec-item>
</ng-template>

<ng-template #CHECK_LEGAL_AGE>
    <tec-item
        [classes]="['item--outline']"
        [outline]="true"
        [tagImage]="{icon: 'icon-list-ticks', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.OCR?.antifraud?.LEGAL_AGE)"
        [title]="'PROCESSES.DETAIL.LEGAL_AGE' | translate"
        [clickeable]="false">
        <tec-list-detail>
            <span>{{ 'PROCESSES.DETAIL.YEARS' | translate: {years_old: processHelper.yearsOld} }}</span>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_POL_ANTISPOOF>
    <tec-item [classes]="['item--outline']"
        [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.POL?.antifraud?.ANTISPOOF)"
        [title]="'PROCESSES.DETAIL.ANTISPOOF' | translate"
        [clickeable]="false">
        <tec-list-detail>
        </tec-list-detail>
    </tec-item>
</ng-template>

<ng-template #CHECK_POL_ANTISPOOF_LAB>
    <tec-item [classes]="['item--outline']"
        [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
        [tagIcon]="getTagIconItem(detail?.data?.POL?.antifraud?.ANTISPOOF_LAB)"
        [title]="'PROCESSES.DETAIL.ANTISPOOF_LAB' | translate"
        [clickeable]="false">
        <tec-list-detail>
            @if (antispoofLabPhasesDisagree() === true) {
                <span>{{ 'PROCESSES.DETAIL.ANTISPOOF_LAB_PHASES_DISAGREE' | translate }}</span>
            }
            @if (antispoofLabPhasesDisagree() === false) {
                <span>{{ 'PROCESSES.DETAIL.ANTISPOOF_LAB_PHASES_AGREE' | translate }}</span>
            }
        </tec-list-detail>
    </tec-item>
</ng-template>

